import {useSetRecoilState} from 'recoil';
import {useQuery} from 'react-query';
import actions from '../../api/user/currentUser';
import {currentUser} from '../../state/user/currentUser';

const useRefetchCurrentUser = () => {
  const setCurrentUser = useSetRecoilState(currentUser);
  return useQuery('fetchCurrentUser', async () => {
    const user = await actions.fetchCurrentUser();
    setCurrentUser(user?.data);
    return user;
  }, {enabled: false, refetchOnWindowFocus: false});
};

export default useRefetchCurrentUser;
